import { render, staticRenderFns } from "./InstitutionRegister.vue?vue&type=template&id=1a1e73f0"
import script from "./InstitutionRegister.vue?vue&type=script&lang=js"
export * from "./InstitutionRegister.vue?vue&type=script&lang=js"
import style0 from "./InstitutionRegister.vue?vue&type=style&index=0&id=1a1e73f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports